import React from "react";

const useQueryParam = () => {
  return Object.fromEntries(new URLSearchParams(window.location.search));
};

export default useQueryParam;
